const ReportTypes = {
	GET_REPORTS: 'GET_REPORTS',
	UPDATE_REPORTS: 'UPDATE_REPORTS',
	SELECT_REPORTS: 'SELECT_REPORTS',
	// ADD_REPLY: 'ADD_REPLY',
}

export default ReportTypes
